var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 36,
    viewBox: "0 0 58 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.035 35.084C26.4983 35.0236 24.4055 33.9335 23.0692 31.6582C21.6994 29.3062 21.7591 26.8984 23.2195 24.6045C26.6964 19.1451 30.2186 13.7159 33.7194 8.27279C34.4353 7.15953 35.1345 6.03 35.8838 4.93766C36.8785 3.44361 38.4328 2.38677 40.2157 1.99217C41.9986 1.59758 43.8692 1.8964 45.4292 2.82502C48.7247 4.80286 49.8272 8.91658 47.7749 12.1587C43.5798 18.8135 39.3249 25.4357 35.0104 32.0254C33.6812 34.0637 31.6648 35.0468 29.035 35.084Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30208 35.0838C4.74154 35.0234 2.66065 33.8845 1.35055 31.6185C-0.000120282 29.2665 0.085788 26.854 1.551 24.5601C5.29119 18.7157 9.04809 12.8798 12.8217 7.05241C13.299 6.29939 13.7762 5.52778 14.2869 4.798C15.3224 3.33639 16.9014 2.32466 18.6895 1.97701C20.4775 1.62937 22.3343 1.9731 23.8667 2.93544C25.3991 3.89779 26.4868 5.40318 26.8995 7.1329C27.3122 8.86263 27.0175 10.6809 26.0778 12.2027C21.8969 18.7777 17.6588 25.3294 13.4183 31.8742C12.0414 33.9961 10.0154 35.0466 7.30208 35.0838Z",
    fill: "#FF3D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8971 21.757C54.7558 21.7756 57.8795 24.7621 57.8723 28.4249C57.8723 32.1435 54.6651 35.1417 50.7706 35.0952C46.8761 35.0487 43.8072 32.0947 43.812 28.4156C43.8168 24.6831 46.9524 21.7337 50.8971 21.757Z",
    fill: "#00D647"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 35,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.bc8969fe3b4be1e251f121865075162e.svg";
export { ForwardRef as ReactComponent };